/**
 * @template T
 * @typedef {Object} ApiResponse
 * @property {boolean} success - Whether the request was successful
 * @property {string} message - Response message
 * @property {T|null} data - Response data (generic, varies per endpoint)
 * @property {string[]|null} errors - List of error messages
 * @property {string} timestamp - Response timestamp (ISO string)
 * @property {string|null} traceId - Trace ID for debugging
 * @property {string|null} correlationId - Correlation ID
 * @property {number} statusCode - HTTP status code
 */

/**
 * Parses a raw JSON response from the backend into an ApiResponse object
 * @template T
 * @param {Object} raw - Raw JSON object from fetch response
 * @returns {ApiResponse<T>} The typed API response
 */
export const parseApiResponse = (raw) => ({
    success: raw.success ?? false,
    message: raw.message ?? '',
    data: raw.data ?? null,
    errors: raw.errors ?? null,
    timestamp: raw.timestamp ?? '',
    traceId: raw.traceId ?? null,
    correlationId: raw.correlationId ?? null,
    statusCode: raw.statusCode ?? 200,
});
